import { render, staticRenderFns } from "./InviteAddDialog.vue?vue&type=template&id=504a420e&scoped=true"
import script from "./InviteAddDialog.vue?vue&type=script&lang=js"
export * from "./InviteAddDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteAddDialog.vue?vue&type=style&index=0&id=504a420e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a420e",
  null
  
)

export default component.exports